import { Record, List } from "immutable";


export class SupplyChainListRecord extends Record({
    id: null,
    seller: null,
    anchor: null,
    // seller_erp: null,
    // ledger_name: null,
    // acceptable: null
    description: null,
    scheme: null,
    processing_fee_amount: null,
    los_company_scheme_id: null,
    scheme_name : null,
    dwd_sp_description : null,
    sub_limit: null,
    scheme_description :null,
    updated_by_user : null
}){}

export class FacilityAccountRecord extends Record({
    id: null,
    agreement_id: null,
    sanction_date: null,
    agreement_tenor: null,
    agreement_end_date: null,
    disbursal_account: null,
    collection_account: null,
    supply_chains: new List([]),
    anchor_relationship_manager: null    
}){
    getJSONvalues() {
        return { 
            id: this.id,
            agreement_id: this.agreement_id,
            sanction_date: this.sanction_date && this.sanction_date.format("YYYY-MM-DD"),
            agreement_end_date: this.agreement_end_date && this.agreement_end_date.format("YYYY-MM-DD"),
            agreement_tenor: this.agreement_tenor,
            anchor_relationship_manager: this.anchor_relationship_manager && this.anchor_relationship_manager.map(_ => _.id)
            // disbursal_account: this.disbursal_account && this.disbursal_account.id,
            // collection_account: this.collection_account && this.collection_account.id,
            // supply_chains: this.supply_chains && this.supply_chains.map(_ => _.id)
        };
    }

    getSupplyChains() {
        return this.supply_chains.map(_ => ({ 
            anchor: _.anchor && _.anchor.id,
            seller: _.seller && _.seller.id,
            scheme: _.scheme,
            id: _.id,
            processing_fee_amount: _.processing_fee_amount,
            los_company_scheme_id: _.los_company_scheme_id
        })).toJS();
    }
}